/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PreferencesRouteImport } from './routes/preferences'
import { Route as MassUnsubscribeRouteImport } from './routes/mass-unsubscribe'
import { Route as LabelsRouteImport } from './routes/labels'
import { Route as InboxZeroRouteImport } from './routes/inbox-zero'
import { Route as GettingStartedRouteImport } from './routes/getting-started'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as EmailProductivityRouteImport } from './routes/email-productivity'
import { Route as EmailOrganizationRouteImport } from './routes/email-organization'
import { Route as EmailCleanupRouteImport } from './routes/email-cleanup'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthErrorRouteImport } from './routes/auth/error'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PreferencesRoute = PreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const MassUnsubscribeRoute = MassUnsubscribeRouteImport.update({
  id: '/mass-unsubscribe',
  path: '/mass-unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const LabelsRoute = LabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxZeroRoute = InboxZeroRouteImport.update({
  id: '/inbox-zero',
  path: '/inbox-zero',
  getParentRoute: () => rootRouteImport,
} as any)
const GettingStartedRoute = GettingStartedRouteImport.update({
  id: '/getting-started',
  path: '/getting-started',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailProductivityRoute = EmailProductivityRouteImport.update({
  id: '/email-productivity',
  path: '/email-productivity',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailOrganizationRoute = EmailOrganizationRouteImport.update({
  id: '/email-organization',
  path: '/email-organization',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailCleanupRoute = EmailCleanupRouteImport.update({
  id: '/email-cleanup',
  path: '/email-cleanup',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareRoute = CompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/billing': typeof BillingRoute
  '/compare': typeof CompareRoute
  '/email-cleanup': typeof EmailCleanupRoute
  '/email-organization': typeof EmailOrganizationRoute
  '/email-productivity': typeof EmailProductivityRoute
  '/features': typeof FeaturesRoute
  '/getting-started': typeof GettingStartedRoute
  '/inbox-zero': typeof InboxZeroRoute
  '/labels': typeof LabelsRoute
  '/mass-unsubscribe': typeof MassUnsubscribeRoute
  '/preferences': typeof PreferencesRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/signin': typeof AuthSigninRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/billing': typeof BillingRoute
  '/compare': typeof CompareRoute
  '/email-cleanup': typeof EmailCleanupRoute
  '/email-organization': typeof EmailOrganizationRoute
  '/email-productivity': typeof EmailProductivityRoute
  '/features': typeof FeaturesRoute
  '/getting-started': typeof GettingStartedRoute
  '/inbox-zero': typeof InboxZeroRoute
  '/labels': typeof LabelsRoute
  '/mass-unsubscribe': typeof MassUnsubscribeRoute
  '/preferences': typeof PreferencesRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/signin': typeof AuthSigninRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/billing': typeof BillingRoute
  '/compare': typeof CompareRoute
  '/email-cleanup': typeof EmailCleanupRoute
  '/email-organization': typeof EmailOrganizationRoute
  '/email-productivity': typeof EmailProductivityRoute
  '/features': typeof FeaturesRoute
  '/getting-started': typeof GettingStartedRoute
  '/inbox-zero': typeof InboxZeroRoute
  '/labels': typeof LabelsRoute
  '/mass-unsubscribe': typeof MassUnsubscribeRoute
  '/preferences': typeof PreferencesRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/signin': typeof AuthSigninRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/billing'
    | '/compare'
    | '/email-cleanup'
    | '/email-organization'
    | '/email-productivity'
    | '/features'
    | '/getting-started'
    | '/inbox-zero'
    | '/labels'
    | '/mass-unsubscribe'
    | '/preferences'
    | '/pricing'
    | '/privacy'
    | '/rules'
    | '/settings'
    | '/terms'
    | '/auth/error'
    | '/auth/signin'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/billing'
    | '/compare'
    | '/email-cleanup'
    | '/email-organization'
    | '/email-productivity'
    | '/features'
    | '/getting-started'
    | '/inbox-zero'
    | '/labels'
    | '/mass-unsubscribe'
    | '/preferences'
    | '/pricing'
    | '/privacy'
    | '/rules'
    | '/settings'
    | '/terms'
    | '/auth/error'
    | '/auth/signin'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/billing'
    | '/compare'
    | '/email-cleanup'
    | '/email-organization'
    | '/email-productivity'
    | '/features'
    | '/getting-started'
    | '/inbox-zero'
    | '/labels'
    | '/mass-unsubscribe'
    | '/preferences'
    | '/pricing'
    | '/privacy'
    | '/rules'
    | '/settings'
    | '/terms'
    | '/auth/error'
    | '/auth/signin'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  BillingRoute: typeof BillingRoute
  CompareRoute: typeof CompareRoute
  EmailCleanupRoute: typeof EmailCleanupRoute
  EmailOrganizationRoute: typeof EmailOrganizationRoute
  EmailProductivityRoute: typeof EmailProductivityRoute
  FeaturesRoute: typeof FeaturesRoute
  GettingStartedRoute: typeof GettingStartedRoute
  InboxZeroRoute: typeof InboxZeroRoute
  LabelsRoute: typeof LabelsRoute
  MassUnsubscribeRoute: typeof MassUnsubscribeRoute
  PreferencesRoute: typeof PreferencesRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  RulesRoute: typeof RulesRoute
  SettingsRoute: typeof SettingsRoute
  TermsRoute: typeof TermsRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthSigninRoute: typeof AuthSigninRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preferences': {
      id: '/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof PreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mass-unsubscribe': {
      id: '/mass-unsubscribe'
      path: '/mass-unsubscribe'
      fullPath: '/mass-unsubscribe'
      preLoaderRoute: typeof MassUnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labels': {
      id: '/labels'
      path: '/labels'
      fullPath: '/labels'
      preLoaderRoute: typeof LabelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox-zero': {
      id: '/inbox-zero'
      path: '/inbox-zero'
      fullPath: '/inbox-zero'
      preLoaderRoute: typeof InboxZeroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/getting-started': {
      id: '/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof GettingStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-productivity': {
      id: '/email-productivity'
      path: '/email-productivity'
      fullPath: '/email-productivity'
      preLoaderRoute: typeof EmailProductivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-organization': {
      id: '/email-organization'
      path: '/email-organization'
      fullPath: '/email-organization'
      preLoaderRoute: typeof EmailOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-cleanup': {
      id: '/email-cleanup'
      path: '/email-cleanup'
      fullPath: '/email-cleanup'
      preLoaderRoute: typeof EmailCleanupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare': {
      id: '/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  BillingRoute: BillingRoute,
  CompareRoute: CompareRoute,
  EmailCleanupRoute: EmailCleanupRoute,
  EmailOrganizationRoute: EmailOrganizationRoute,
  EmailProductivityRoute: EmailProductivityRoute,
  FeaturesRoute: FeaturesRoute,
  GettingStartedRoute: GettingStartedRoute,
  InboxZeroRoute: InboxZeroRoute,
  LabelsRoute: LabelsRoute,
  MassUnsubscribeRoute: MassUnsubscribeRoute,
  PreferencesRoute: PreferencesRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  RulesRoute: RulesRoute,
  SettingsRoute: SettingsRoute,
  TermsRoute: TermsRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthSigninRoute: AuthSigninRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
